<template>

	<div
		class="m-layout"
		:style="{
			'border-top':
				!showTopBar
					? 'none'
					: ''
		}"
	>

		<!-- 手机菜单 -->
		<MobileMenu
			ref="menu"
			:isOpen="menuOpen"
			@close="closeMenu"
			@search="showSearch"
		/>

		<!-- 搜索 -->
		<transition name="fade">

			<div
				v-if="searchOpen"
				class="m-search-drawer"
			>

				<div
					class="m-search-mask"
					@click="closeSearch"
					@touchmove.prevent
				></div>

				<div class="m-search-sheet">

					<MobileSearch
						:visible="searchOpen"
						@update:visible="
							searchOpen = $event
						"
						@close="closeSearch"
						section=""
					/>

				</div>

			</div>

		</transition>

		<!-- 页面内容 -->
		<main class="m-content">

			<slot />

		</main>

		<!-- 底部导航 -->
		<Teleport to="body">

			<div
				class="m-bottom-bar"
				v-if="!hideBottomBar"
			>

				<!-- 左侧 -->
				<div class="m-bottom-bar-icons">

					<button
						class="m-icon-btn"
						@click="showSearch"
					>

						<img
							:src="searchIcon"
							alt="search"
							style="
								width: 12rem;
								height: 13rem;
							"
						/>

					</button>

					<button
						class="m-icon-btn"
						@click="goEnquiry"
					>

						<img
							:src="bagIcon"
							alt="bag"
							style="
								width: 11rem;
								height: 13rem;
							"
						/>

					</button>

				</div>

				<!-- Menu -->
				<button
					class="m-menu-trigger"
					@click="openMenu"
				>
					Menu
				</button>

				<!-- 右侧 -->
				<div
					class="m-bottom-bar-icons"
					style="
						justify-content: flex-end;
					"
				>

					<button
						class="m-icon-btn"
						@click="openEmail"
					>

						<img
							:src="miniLogo"
							alt="logo"
							style="
								width: 9rem;
								height: 11rem;
							"
						/>

					</button>

					<button
						class="m-icon-btn"
						@click="goAccount"
					>

						<img
							:src="userIcon"
							alt="user"
							style="
								width: 11rem;
								height: 12rem;
							"
						/>

					</button>

				</div>

			</div>

		</Teleport>

		<!-- Email -->
		<MobileEmail
			:visible.sync="emailOpen"
			:auto-show-delay="0"
			@close="onEmailClose"
		/>

	</div>

</template>

<script>
import MobileMenu from './Menu.vue'
import MobileSearch from './search.vue'
import MobileEmail from './email.vue'

const searchIcon =
	require('@/assets/icon/search_black.png')

const bagIcon =
	require('@/assets/icon/product_black.png')

const userIcon =
	require('@/assets/icon/user_black.png')

const miniLogo =
	require('@/assets/icon/logo_black.png')

const APP_VERSION = '1.0.1'

export default {

	name: 'MobileLayout',

	components: {

		MobileMenu,

		MobileSearch,

		MobileEmail

	},

	props: {

		showTopBar: {

			type: Boolean,

			default: true

		},

		hideBottomBar: {

			type: Boolean,

			default: false

		}

	},

	data() {

		return {

			menuOpen: false,

			searchOpen: false,

			emailOpen: false,

			searchIcon,

			bagIcon,

			userIcon,

			miniLogo

		}

	},

	mounted() {

		/**
		 * 检查版本
		 */
		this.checkVersionAndClearCache()

        // ★ 新增：检查邮件链接 ?opensubscribe=true
        this.checkSubscribeParam()
		  
		window.addEventListener(
			'open-auto-email-popup',
			this.handleAutoEmailPopup
		)

		/**
		 * 页面首次加载时
		 * 检测是否需要恢复菜单
		 */
		this.openMenuIfNeeded()

	},

	beforeDestroy() {

		window.removeEventListener(
			'open-auto-email-popup',
			this.handleAutoEmailPopup
		)

	},

	watch: {

		/**
		 * 浏览器 Back / Forward
		 * 或 Vue Router 路由变化时执行。
		 */
		$route() {

			this.openMenuIfNeeded()

		}

	},

	methods: {
		/**
		 * 邮件链接 ?opensubscribe=true 立即弹窗
		 */
		checkSubscribeParam() {
		  const fromSearch = new URLSearchParams(window.location.search).get('opensubscribe')
		  if (fromSearch !== 'true') return

		  // 立即弹
		  this.emailOpen = true

		  // 清理 URL，防止刷新重复弹
		  const url = new URL(window.location.href)
		  url.searchParams.delete('opensubscribe')
		  window.history.replaceState({}, document.title, url.toString())
		},
		
		/**
		 * 清理旧版本缓存
		 */
		checkVersionAndClearCache() {

			const storedVersion =
				localStorage.getItem(
					'app_version_mobile'
				)

			if (
				storedVersion &&
				storedVersion !== APP_VERSION
			) {

				if ('caches' in window) {

					caches
						.keys()
						.then(names =>
							names.forEach(
								name =>
									caches.delete(
										name
									)
							)
						)

				}

				sessionStorage.clear()

				localStorage.setItem(
					'app_version_mobile',
					APP_VERSION
				)

				window.location.reload(true)

				return

			}

			if (!storedVersion) {

				localStorage.setItem(
					'app_version_mobile',
					APP_VERSION
				)

			}

		},

		/**
		 * 自动 Email
		 */
		handleAutoEmailPopup() {

			this.emailOpen = true

		},

		openEmailPopup() {

			this.emailOpen = true

		},

		onEmailClose() {

			localStorage.setItem(
				'emailAutoShown',
				'true'
			)

			this.emailOpen = false

		},

		/**
		 * 打开 Menu
		 */
		openMenu() {

			this.menuOpen = true

		},

		/**
		 * 关闭 Menu
		 *
		 * 注意：
		 *
		 * 这里只负责 UI 关闭。
		 *
		 * 不清除 sessionStorage.menuState。
		 *
		 * menuState 是否消费，
		 * 由 Menu.vue 的 restoreState() 决定。
		 */
		closeMenu() {

			this.menuOpen = false

		},

		/**
		 * 打开搜索
		 */
		showSearch() {

			this.menuOpen = false

			this.searchOpen = true

		},

		/**
		 * 关闭搜索
		 */
		closeSearch() {

			this.searchOpen = false

		},

		/**
		 * 打开 Email
		 */
		openEmail() {

			this.emailOpen = true

		},

		/**
		 * Account
		 */
		goAccount() {

			if (
				this.$route.path !==
				'/m/account'
			) {

				this.$router.push(
					'/m/account'
				)

			}

		},

		/**
		 * Enquiry
		 */
		goEnquiry() {

			if (
				this.$route.path !==
				'/m/enquiry'
			) {

				this.$router.push(
					'/m/enquiry'
				)

			}

		},

		/**
		 * 判断是否需要自动恢复 Menu
		 *
		 * 核心逻辑：
		 *
		 * Menu
		 * ↓
		 * ABOUT
		 * ↓
		 * About Us
		 *
		 * menuState:
		 *
		 * {
		 *   tab: 'info',
		 *   section: 'about',
		 *   title: 'ABOUT',
		 *   returnPath: '/m/home'
		 * }
		 *
		 * 当前：
		 *
		 * /m/about
		 *
		 * 不打开菜单。
		 *
		 * 浏览器 Back：
		 *
		 * /m/home
		 *
		 * 发现：
		 *
		 * /m/home === returnPath
		 *
		 * 才打开菜单。
		 */
		openMenuIfNeeded() {

			const raw =
				sessionStorage.getItem(
					'menuState'
				)

			if (!raw) {
				return
			}

			try {

				const state =
					JSON.parse(raw)

				/**
				 * 只有当前路由
				 * 等于进入详情页之前的路由
				 * 才打开 Menu。
				 *
				 * 这一步是整个修复的关键。
				 */
				if (
					state.returnPath &&
					this.$route.fullPath ===
						state.returnPath
				) {

					this.menuOpen = true

				}

			} catch (e) {

				/**
				 * JSON 解析失败，
				 * 清理错误状态。
				 */
				sessionStorage.removeItem(
					'menuState'
				)

			}

		}

	}

}
</script>

<style scoped>
.m-layout {
	min-height: 100vh;
	width: 100%;
	overflow-x: hidden;
	background: #ffffff;
	color: #000;
	display: flex;
	flex-direction: column;
}

.m-content {
	flex: 1;
	padding-bottom:
		calc(
			45rem +
			constant(
				safe-area-inset-bottom
			)
		);

	padding-bottom:
		calc(
			45rem +
			env(
				safe-area-inset-bottom
			)
		);

	overflow-y: auto;

	-webkit-overflow-scrolling: touch;

	opacity: 1;
}

.m-bottom-bar {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;

	height: 45rem;

	background: #000;

	display: flex;

	align-items: center;

	justify-content: space-between;

	padding: 0 28rem;

	padding-bottom:
		constant(
			safe-area-inset-bottom
		);

	padding-bottom:
		env(
			safe-area-inset-bottom
		);

	box-sizing: content-box;

	z-index: 99999 !important;
}

.m-bottom-bar-icons {
	display: flex;
	gap: 20rem;
	width: 40%;
}

.m-icon-btn {
	background: none;
	border: none;
	padding: 0;

	display: flex;

	align-items: center;

	justify-content: center;
}

.m-icon-btn img {
	width: 18rem;
	height: 18rem;

	filter: invert(1);
}

.m-menu-trigger {
	background: none;
	border: none;

	font-size: 13rem;

	color: #fff;

	font-family:
		'Apercu-Medium',
		sans-serif !important;
}

.m-search-drawer {
	position: fixed;

	left: 0;
	right: 0;
	bottom: 0;
	top: 0;

	height: 100vh;

	z-index: 9998 !important;

	display: flex;

	align-items:
		flex-start !important;

	overflow: hidden;

	overscroll-behavior: contain;
}

.m-search-mask {
	position: absolute;

	top: 0;
	left: 0;

	width: 100%;
	height: 100%;

	background:
		rgba(
			0,
			0,
			0,
			0.35
		);

	cursor: pointer;

	pointer-events: auto;

	z-index: 0;
}

.m-search-sheet {
	position: relative;

	width: 100%;

	height:
		calc(
			100vh -
			45rem -
			env(
				safe-area-inset-bottom,
				0px
			)
		);

	max-height:
		calc(
			100vh -
			45rem -
			env(
				safe-area-inset-bottom,
				0px
			)
		);

	display: flex;

	flex-direction: column;

	overflow: hidden;

	align-self: flex-start;

	pointer-events: auto;

	z-index: 1;

	touch-action: pan-y;
}

.fade-enter-active,
.fade-leave-active {
	transition:
		opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>